import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { ApiUrlConstants } from '../../common/constants/api.constants';
import { Forever2DriveDetail } from '../interface/forever-drive-details';
import { GemBonusDetail } from '../interface/gem-bonus-details';
import { LeadershipIncentiveDetails } from '../interface/leadershipincentivedetails';



@Injectable()
export class IncentiveReportService {

    private observable: Observable<any>;

    constructor(private _http: Http) {

    }

    /**
   * To handle the obervable error response
   * @param  {Response|any} error
   */
    private handleErrorObservable(error: Response | any) {
        return Observable.throw(error);
    }

    getLeadershipDetails(distributorId: string, homeCountry: string): Observable<LeadershipIncentiveDetails> {

        const _url = ApiUrlConstants.reportApiUrl;
        const url: string = _url + '/distributorId/' + distributorId + '/country/' + homeCountry + '/leadership-incentives';

        this.observable = this._http
            .get(url)
            .map((res: Response) => res.json());

        return this.observable;
    }


    /**
   * getChairmansBonusDetails Method used to get ccs of logged in fbo
   * @param  {number} distributorId
   * @param  {string} country
   * @returns Observable
   */
    getChairmansBonusDetails(distributorId: string, countryCode: string, processingYear: number): Observable<any> {
        let url: string = ApiUrlConstants.reportApiUrl + '/distributors/' + distributorId + '/countryCode/' + countryCode +
            '/chairmansbonus';
        if (processingYear) {
            url = url + '?processingYear=' + processingYear;
        }
        return this._http
            .get(decodeURIComponent(encodeURIComponent(url)))
            .map((res: Response) => res.json())
            .catch(this.handleErrorObservable);
    }
    getGembonusDetails(distributorId: string, homeCountry: string): Observable<GemBonusDetail> {

        const url = ApiUrlConstants.reportApiUrl + '/distributors/' + distributorId + '/gem-bonus?' + 'countryCode=' + homeCountry;

        return this.observable = this._http
            .get(url)
            .map((res: Response) => res.json());
    }

    getEarnedIncentiveDetails(distributorId: string, homeCountry: string): Observable<Forever2DriveDetail> {

        const url = ApiUrlConstants.reportApiUrl + '/distributors/' + distributorId + '/earned-incentive?' + 'countryCode=' + homeCountry;

        return this.observable = this._http
            .get(url)
            .map((res: Response) => res.json());
    }

    getEagleManagerDetails(distributorId: string, countryCode: string, processingYear: string): Observable<any> {
        let url: string = ApiUrlConstants.reportApiUrl + '/distributors/' + distributorId + '/eagle-manager?';
        if (countryCode) {
            url = url + 'countryCode=' + countryCode;
        }
        if (processingYear) {
            url = url + '&selectedYear=' + processingYear;
        }
        return this._http
            .get(decodeURIComponent(encodeURIComponent(url)))
            .map((res: Response) => res.json())
            .catch(this.handleErrorObservable);
    }

    getGlobalRallyIncentives(distributorId: string, countryCode: string, processingYear: string, processingMonth: string): Observable<any> {
        let url: string = ApiUrlConstants.reportApiUrl + '/distributors/' + distributorId + '/globalrally-incentives?';
        if (countryCode) {
            url = url + 'countryCode=' + countryCode;
        }
        if (processingYear) {
            url = url + '&selectedYear=' + processingYear;
        }
        if (processingMonth) {
            url = url + '&selectedMonth=' + processingMonth;
        }
        return this._http
            .get(decodeURIComponent(encodeURIComponent(url)))
            .map((res: Response) => res.json())
            .catch(this.handleErrorObservable);
    }


    getViewIncentiveDetails(distributorId: string, countryCode: string, processingYear: string, isEagleManager: boolean): Observable<any> {
        let url: string = ApiUrlConstants.reportApiUrl + '/distributors/' + distributorId + '/view-incentive?';
        if (countryCode) {
            url = url + 'countryCode=' + countryCode;
        }
        if (processingYear) {
            url = url + '&selectedYear=' + processingYear;
        }
        url = url + '&isEagleManager=' + isEagleManager;

        return this.observable = this._http
            .get(url)
            .map((res: Response) => res.json());
    }

    /**
     * @description Request to get Global Rally, Leadership Bonus and Gem Bonus Details
     * @date 2020-03-19
     * @param {string} distributorId
     * @param {string} countryCode
     * @param {string} incentivesType
     * @returns
     * @memberof IncentiveReportService
     */
    getIncentivesDetails(
        distributorId: string,
        countryCode: string,
        incentivesType: string
    ) {
        const url = ApiUrlConstants.reportApiUrl + '/performance/fboId/' +
            distributorId +
            '/country/' +
            countryCode +
            '/widget/' + incentivesType;
        return this._http
            .get(decodeURIComponent(encodeURIComponent(url)))
            .map((res: Response) => res.json())
            .catch(this.handleErrorObservable);
    }

    /**
     * @description Request to get Forever2Drive Incentives Details
     * @date 2020-03-19
     * @param {string} distributorId
     * @param {string} countryCode
     * @param {string} incentivesType
     * @param {string} year
     * @returns
     * @memberof IncentiveReportService
     */
    getEarnedIncentivesDetails(
        distributorId: string,
        countryCode: string,
        incentivesType: string,
        year: string,
        month: number
    ) {
        const url = ApiUrlConstants.reportApiUrl + '/performance/fboId/' +
            distributorId +
            '/country/' +
            countryCode +
            '/widget-' + incentivesType + '?year=' + year + '&month=' + month ;
        return this.observable = this._http
            .get(url)
            .map((res: Response) => res.json());
    }

    /**
     * @description Request to get Eagle Manager Incentive Details
     * @date 2020-03-19
     * @param {string} distributorId
     * @param {string} countryCode
     * @param {string} incentivesType
     * @param {number} year    
     * @returns
     * @memberof IncentiveReportService
     */
    getEagleManagerIncentivesDetails(
        distributorId: string,
        countryCode: string,
        incentivesType: string,
        year: number        
    ) {
        const url = ApiUrlConstants.reportApiUrl + '/' + incentivesType + '/fboId/' +
            distributorId +
            '/country/' +
            countryCode +
            // '/widget/' + incentivesType +
            '?year=' + year;
        return this._http
            .get(decodeURIComponent(encodeURIComponent(url)))
            .map((res: Response) => res.json())
            .catch(this.handleErrorObservable);
    }

    /**
   *
   * @description Get Chairman Bonus incentives report
   * @param {string} distributorId
   * @param {string} countryCode
   * @param {string} incentivesType
   * @returns IncentiveDetailsResponse
   * @memberof ReportsService
   */
    getIncentivesDetailsView(
        distributorId: string,
        countryCode: string,
        incentivesType: string
    ) {
        const url = ApiUrlConstants.reportApiUrl + '/performance/fboId/' +
            distributorId +
            '/country/' +
            countryCode +
            '/widget/' + incentivesType;
        return this.observable = this._http
            .get(url)
            .map((res: Response) => res.json());
    }
}



// WEBPACK FOOTER //
// ./src/app/customerservice/services/view-incentives.service.ts